<template>
	<v-dialog
		v-model="showDialog"
		:width="$vuetify.breakpoint.lgAndUp? '33%':'auto'"
		@click:outside="close()"
		scrollable
	>
		<v-card 
			:key="`pdf_dte_card}${key}`"
			:class="`${failedToLoad?'vista-iframe':''}`"
		>
			<v-card-title class="headline">
				Folio Nro {{folio}}
				<v-spacer/>
				<v-btn
					icon outlined
					color="primary"
					v-if="canShare"
					@click="compartir"
				>
					<v-icon>
						share
					</v-icon>
				</v-btn>
			</v-card-title>
			<v-divider/>
			<v-card-text v-if="!error.is">

				<iframe
					v-if="failedToLoad"
					:src="pdf_url" 
					width="100%" 
					height="100%"
				></iframe>
				<vue-pdf 
					v-else
					:src="pdf_url"
					style=""
					@error="loadError"
				/>
			</v-card-text>

			<v-alert
				border="left"
				colored-border
				type="error"
				elevation="2"
				v-else
			>
				{{error.msg}}
			</v-alert>
				<v-divider/>
			<v-card-actions>
				<v-btn
					color="error"
					outlined
					@click="close()"
				>
					Cerrar
				</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>

import vuePdf from 'vue-pdf';
import axios from 'axios';

import * as NavigatorShareUtils from '@/library/utils/nav-share';

export default {
	name: 'DteEmitidoVista',
	components:{
		vuePdf
	},
	props:{
		display:{
			type: Boolean,
			default: false
		},
		folio:{
			type: Number,
			default: 1
		},
		url:{
			type: String,
		},
	},
	computed:{
		pdf_url:{
			set(val){
				this.pdf = val;
			},
			get(){
				return this.pdf || this.url;
			}
		},
		canShare(){
			return NavigatorShareUtils.puedeCompartir() || false;
		}
	},
	data () {
		return {
			showDialog: false,
			isloading: false,
			error:{
				is: false,
				msg: ''
			},
			pdf: undefined,
			failedToLoad: false,
			key:0,
		}
	},
	methods: {
		loadPDF: async function(){

			let rl = this.url.split('.pdf')[0]+'.pdf';

			try{
				let resp = await axios({
					method:'GET',
					url: this.url,
				});

			}catch(err){
				
			}
		},
		close: function(){

			this.pdf_url = undefined;

			this.showDialog = false;
			this.$emit('close');
		},
		loadError: function(){
			this.failedToLoad = true;
		},
		showPdf: function(){
			this.showDialog = true;
			this.error.is = false;
			this.isloading = false;
			this.failedToLoad = false;
			this.key++;
		},
		compartir: async function(){
			let vm = this;
			let url = vm.pdf_url;
			let text = 'Se ha emitido una boleta';
			let title = 'Boleta';
			
			const empr = vm.$store.getters['empresas/seleccionada']||{}
			
			const razonSocial = empr.razon_social
			
			const rut = empr.rut + '-' + empr.dv
			
			const fileName = `Boleta_${rut}-${this.folio}.pdf`
			
			const fileConfig = {
				url, fileName, rut
			}
			
			NavigatorShareUtils.compartir(url, text, title, fileConfig);
		}
	},
	watch:{
		async display(val){
			if(val){
				this.showPdf()
			}
		}
	}
}
</script>

<style lang="css" scoped>
	.vista-iframe {
		height:80vh;
	}
	.lg-up{
		width: 10% !important;
	}
	 
</style>